module.exports = __webpack_public_path__ + "img/AndorLandor.5bab36d2.png";